<template>

    <div class="data-table-container">


        <div class="scrollable-table">

            <table class="site-data table table-bordered table-striped">


                <thead>

                    <tr>


                        <!--<editor-fold desc="HEADERS">-->


                            <!--<editor-fold desc="GENERAL">-->

                            <DataTableHeader v-if="visibleFields.order_date"
                                             :field="'order_date'"
                                             :label="'Date'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="visibleFields.site"
                                             :field="'site'"
                                             :label="'Site'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader :field="'document_number'"
                                             :label="'Document'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>

                            <DataTableHeader v-if="viewMode === 'overview' && visibleFields.material_description"
                                             :field="'material_description'"
                                             :label="'Material'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && visibleFields.ewc_code"
                                             :field="'ewc_code'"
                                             :label="'EWC Code'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && visibleFields.quantity"
                                             :field="'quantity'"
                                             :is-centred="true"
                                             :label="'Qty.'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && visibleFields.unit_of_measure"
                                             :field="'unit_of_measure'"
                                             :is-centred="true"
                                             :label="'Unit'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.percentage === true && visibleFields.recycled"
                                             :field="'recycled'"
                                             :is-vertical="true"
                                             :label="'Recycled'"
                                             :sort="sort"
                                             units="%"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.percentage === true && visibleFields.rdf"
                                             :field="'rdf'"
                                             :is-vertical="true"
                                             :label="'RDF'"
                                             :sort="sort"
                                             units="%"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.percentage === true && visibleFields.landfill"
                                             :field="'landfill'"
                                             :is-vertical="true"
                                             :label="'Landfill'"
                                             :sort="sort"
                                             units="%"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.amount === true && visibleFields.recycled"
                                             :field="'recovered_wt'"
                                             :is-vertical="true"
                                             :label="'Recycled'"
                                             :sort="sort"
                                             units="t"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.amount === true && visibleFields.rdf"
                                             :field="'rdf_wt'"
                                             :is-vertical="true"
                                             :label="'RDF'"
                                             :sort="sort"
                                             units="t"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'overview' && viewUnits.amount === true && visibleFields.landfill"
                                             :field="'landfill_wt'"
                                             :is-vertical="true"
                                             :label="'Landfill'"
                                             :sort="sort"
                                             units="t"
                                             v-on:update:sort="updateSortProps"/>

                            <DataTableHeader v-if="viewMode === 'overview'"
                                             :field="'files'"/>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="DETAILS">-->

                            <DataTableHeader v-if="viewMode === 'details' && visibleFields.vehicle_reg"
                                             :field="'vehicle_reg'"
                                             :label="'Vehicle'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'details' && visibleFields.movement_type"
                                             :field="'movement_type'"
                                             :label="'Movement'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'details' && visibleFields.equipment_type"
                                             :field="'equipment_type'"
                                             :label="'Container'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="PROJECT">-->

                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.project_number"
                                             :field="'project_number'"
                                             :label="'Project Number'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.project_name"
                                             :field="'project_name'"
                                             :label="'Project Name'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.carrier_name"
                                             :field="'carrier_name'"
                                             :label="'Carrier Name'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.activity"
                                             :field="'activity'"
                                             :label="'Activity'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.material_category"
                                             :field="'material_category'"
                                             :label="'Material Category'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'project' && visibleFields.waste_facility"
                                             :field="'waste_facility'"
                                             :label="'Waste Facility'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="MATERIALS (%)">-->

                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.aggregates"
                                :field="'aggregates'"
                                :is-vertical="true"
                                :label="'Aggregates'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.asphalt"
                                :field="'asphalt'"
                                :is-vertical="true"
                                :label="'Asphalt'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.bricks"
                                :field="'bricks'"
                                :is-vertical="true"
                                :label="'Bricks'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.bulkyWaste"
                                :field="'bulkyWaste'"
                                :is-vertical="true"
                                :label="'Bulky Waste inc POPs'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.canteenOffice"
                                :field="'canteenOffice'"
                                :is-vertical="true"
                                :label="'Canteen'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.concrete"
                                :field="'concrete'"
                                :is-vertical="true"
                                :label="'Concrete'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.floorCoverings"
                                :field="'floorCoverings'"
                                :is-vertical="true"
                                :label="'Floor Covering'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.glass"
                                :field="'glass'"
                                :is-vertical="true"
                                :label="'Glass'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.greenWaste"
                                :field="'greenWaste'"
                                :is-vertical="true"
                                :label="'Green Waste'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.gypsum"
                                :field="'gypsum'"
                                :is-vertical="true"
                                :label="'Gypsum'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.hazNonConform"
                                :field="'hazNonConform'"
                                :is-vertical="true"
                                :label="'Haz Non Conformance'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.insulation"
                                :field="'insulation'"
                                :is-vertical="true"
                                :label="'Insulation'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.liquids"
                                :field="'liquids'"
                                :is-vertical="true"
                                :label="'Liquids'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.mechTreated"
                                :field="'mechTreated'"
                                :is-vertical="true"
                                :label="'Mech Treated'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.metals"
                                :field="'metals'"
                                :is-vertical="true"
                                :label="'Metal'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.nonHazNonConform"
                                :field="'nonHazNonConform'"
                                :is-vertical="true"
                                :label="'Non Haz Non Conformance'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.other"
                                :field="'other'"
                                :is-vertical="true"
                                :label="'General Landfill'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.packagingPlastic"
                                :field="'packagingPlastic'"
                                :is-vertical="true"
                                :label="'Packaging Plastic'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.packagingCard"
                                :field="'packagingCard'"
                                :is-vertical="true"
                                :label="'Packaging Card'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.paper"
                                :field="'paper'"
                                :is-vertical="true"
                                :label="'Paper'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.plastic"
                                :field="'plastic'"
                                :is-vertical="true"
                                :label="'Plastic'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.plasticNonRecyclable"
                                :field="'plasticNonRecyclable'"
                                :is-vertical="true"
                                :label="'Plastic Non-Recyclable'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.soils"
                                :field="'soils'"
                                :is-vertical="true"
                                :label="'Soils'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.tilesCeramics"
                                :field="'tilesCeramics'"
                                :is-vertical="true"
                                :label="'Tiles'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.weee"
                                :field="'weee'"
                                :is-vertical="true"
                                :label="'WEEE'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.woodNonPackaging"
                                :field="'woodNonPackaging'"
                                :is-vertical="true"
                                :label="'Timber'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.woodPackaging"
                                :field="'woodPackaging'"
                                :is-vertical="true"
                                :label="'Pallets'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.percentage === true && visibleFields.tyres"
                                :field="'tyres'"
                                :is-vertical="true"
                                :label="'Tyres'"
                                :sort="sort"
                                units="%"
                                v-on:update:sort="updateSortProps"/>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="MATERIALS (t)">-->

                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.aggregates"
                                :field="'aggregateWT'"
                                :is-vertical="true"
                                :label="'Aggregates'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.asphalt"
                                :field="'asphaltWT'"
                                :is-vertical="true"
                                :label="'Asphalt'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.bricks"
                                :field="'bricksWT'"
                                :is-vertical="true"
                                :label="'Bricks'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.bulkyWaste"
                                :field="'bulkyWasteWT'"
                                :is-vertical="true"
                                :label="'Bulky Waste inc POPs'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.canteenOffice"
                                :field="'canteenOfficeWT'"
                                :is-vertical="true"
                                :label="'Canteen'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.concrete"
                                :field="'concreteWT'"
                                :is-vertical="true"
                                :label="'Concrete'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.floorCoverings"
                                :field="'floorCoveringsWT'"
                                :is-vertical="true"
                                :label="'Floor Covering'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.glass"
                                :field="'glassWT'"
                                :is-vertical="true"
                                :label="'Glass'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.greenWaste"
                                :field="'greenWasteWT'"
                                :is-vertical="true"
                                :label="'Green Waste'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.gypsum"
                                :field="'gypsumWT'"
                                :is-vertical="true"
                                :label="'Gypsum'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.hazNonConform"
                                :field="'hazNonConformWT'"
                                :is-vertical="true"
                                :label="'Haz Non Conformance'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.insulation"
                                :field="'insulationWT'"
                                :is-vertical="true"
                                :label="'Insulation'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.liquids"
                                :field="'liquidsWT'"
                                :is-vertical="true"
                                :label="'Liquids'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.mechTreated"
                                :field="'mechTreatedWT'"
                                :is-vertical="true"
                                :label="'Mech Treated'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.metals"
                                :field="'metalsWT'"
                                :is-vertical="true"
                                :label="'Metal'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.nonHazNonConform"
                                :field="'nonHazNonConformWT'"
                                :is-vertical="true"
                                :label="'Non Haz Non Conformance'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.other"
                                :field="'otherWT'"
                                :is-vertical="true"
                                :label="'General Landfill'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.packagingPlastic"
                                :field="'packagingPlasticWT'"
                                :is-vertical="true"
                                :label="'Packaging Plastic'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.packagingCard"
                                :field="'packagingCardWT'"
                                :is-vertical="true"
                                :label="'Packaging Card'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.paper"
                                :field="'paperWT'"
                                :is-vertical="true"
                                :label="'Paper'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.plastic"
                                :field="'plasticWT'"
                                :is-vertical="true"
                                :label="'Plastic'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.plasticNonRecyclable"
                                :field="'plasticNonRecyclableWT'"
                                :is-vertical="true"
                                :label="'Plastic Non-Recyclable'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.soils"
                                :field="'soilsWT'"
                                :is-vertical="true"
                                :label="'Soils'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.tilesCeramics"
                                :field="'tilesCeramicsWT'"
                                :is-vertical="true"
                                :label="'Tiles'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.weee"
                                :field="'weeeWT'"
                                :is-vertical="true"
                                :label="'WEEE'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.woodNonPackaging"
                                :field="'woodNonPackagingWT'"
                                :is-vertical="true"
                                :label="'Timber'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.woodPackaging"
                                :field="'woodPackagingWT'"
                                :is-vertical="true"
                                :label="'Pallets'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>
                            <DataTableHeader
                                v-if="viewMode === 'materials' && viewUnits.amount === true && visibleFields.tyres"
                                :field="'tyresWT'"
                                :is-vertical="true"
                                :label="'Tyres'"
                                :sort="sort"
                                units="t"
                                v-on:update:sort="updateSortProps"/>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="CARBON">-->

                            <DataTableHeader v-if="viewMode === 'carbon' && visibleFields.wasteCarbon"
                                             :field="'wasteCarbon'"
                                             :label="'kgCO2e from Waste Generated'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'carbon' && visibleFields.transportCarbon"
                                             :field="'transportCarbon'"
                                             :label="'kgCO2e from Transport'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'carbon' && visibleFields.totalCarbon"
                                             :field="'totalCarbon'"
                                             :label="'Total kgCO2e'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'carbon' && visibleFields.jobDistance"
                                             :field="'jobDistance'"
                                             :label="'Job Distance'"
                                             :sort="sort"
                                             v-on:update:sort="updateSortProps"/>
                            <DataTableHeader v-if="viewMode === 'carbon' && visibleFields.treeCount"
                                             :field="'treeCount'"
                                             :hasTooltip="true"
                                             :label="'Tree Offset Counter'"
                                             :sort="sort"
                                             tooltip-text="This column shows the equivalent number of trees that would need to be planted to offset the carbon emissions saved by Ward."
                                             v-on:update:sort="updateSortProps"/>

                            <!--</editor-fold>-->


                        <!--</editor-fold>-->


                    </tr>

                </thead>


                <tbody>

                    <tr v-for="(row) in this.sortedSiteData">


                        <!--<editor-fold desc="BODY">-->


                            <!--<editor-fold desc="GENERAL">-->

                            <DataTableColumn v-if="visibleFields.order_date"
                                             :field="'document_order_date_human'"
                            >
                                {{ row.document_order_date_human }}
                            </DataTableColumn>
                            <DataTableColumn v-if="visibleFields.site"
                                             :field="'site'">
                                {{ row.site }}
                            </DataTableColumn>
                            <DataTableColumn :field="'document_number'">
                                {{ row.document_number }}
                            </DataTableColumn>

                            <DataTableColumn v-if="viewMode === 'overview' && visibleFields.material_description"
                                             :field="'material_description'"
                            >
                                {{ row.material_description }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'overview' && visibleFields.ewc_code"
                                             :field="'ewc_code'">
                                {{ row.ewc_code }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'overview' && visibleFields.quantity"
                                             :field="'quantity'"
                                             :is-centred="true">
                                {{ row.quantity }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'overview' && visibleFields.unit_of_measure"
                                             :field="'unit_of_measure'"
                                             :is-centred="true">
                                {{ row.unit_of_measure }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.percentage === true && viewMode === 'overview' && visibleFields.recycled"
                                             :field="'recycled'">
                                {{ row.recycled }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.percentage === true && viewMode === 'overview' && visibleFields.rdf"
                                             :field="'rdf'">
                                {{ row.rdf }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.percentage === true && viewMode === 'overview' && visibleFields.landfill"
                                             :field="'landfill'">
                                {{ row.landfill }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.amount === true && viewMode === 'overview' && visibleFields.recycled"
                                             :field="'recovered_wt'">
                                {{ row.recoveredWT }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.amount === true && viewMode === 'overview' && visibleFields.rdf"
                                             :field="'rdf_wt'">
                                {{ row.rdfWT }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewUnits.amount === true && viewMode === 'overview' && visibleFields.landfill"
                                             :field="'landfill_wt'">
                                {{ row.landfillWT }}
                            </DataTableColumn>

                            <DataTableColumn v-if="viewMode === 'overview'"
                                             :field="'files'">
                                <button v-if="filesByLine(row) && filesByLine(row).length > 0"
                                        class="btn btn-link"
                                        title="View files attached to this line"
                                        v-on:click="showFileModal(row)"
                                >
                                    <i class="fas fa-file"></i> {{ filesByLine(row).length }}
                                </button>
                            </DataTableColumn>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="DETAILS">-->

                            <DataTableColumn v-if="viewMode === 'details' && visibleFields.vehicle_reg"
                                             :field="'vehicle_reg'">
                                {{ row.vehicle_reg }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'details' && visibleFields.movement_type"
                                             :field="'movement_type'">
                                {{ row.movement_type }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'details' && visibleFields.equipment_type"
                                             :field="'equipment_type'">
                                {{ row.equipment_type }}
                            </DataTableColumn>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="PROJECT">-->

                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.project_number"
                                             :field="'project_number'">
                                {{ row.project_number }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.project_name"
                                             :field="'project_name'">
                                {{ row.project_name }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.carrier_name"
                                             :field="'carrier_name'">
                                {{ row.carrier_name }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.activity"
                                             :field="'activity'">
                                {{ row.activity }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.material_category"
                                             :field="'material_category'">
                                {{ row.material_category }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'project' && visibleFields.waste_facility"
                                             :field="'waste_facility'">
                                {{ row.waste_facility }}
                            </DataTableColumn>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="MATERIALS (%)">-->

                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.aggregates"
                                :field="'aggregates'"
                                :is-centred="true">
                                {{ row.aggregates }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.asphalt"
                                :field="'asphalt'"
                                :is-centred="true">
                                {{ row.asphalt }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.bricks"
                                :field="'bricks'"
                                :is-centred="true">
                                {{ row.bricks }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.bulkyWaste"
                                :field="'bulkyWaste'"
                                :is-centred="true">
                                {{ row.bulkyWaste }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.canteenOffice"
                                :field="'canteenOffice'"
                                :is-centred="true">
                                {{ row.canteenOffice }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.concrete"
                                :field="'concrete'"
                                :is-centred="true">
                                {{ row.concrete }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.floorCoverings"
                                :field="'floorCoverings'"
                                :is-centred="true">
                                {{ row.floorCoverings }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.glass"
                                :field="'glass'"
                                :is-centred="true">
                                {{ row.glass }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.greenWaste"
                                :field="'greenWaste'"
                                :is-centred="true">
                                {{ row.greenWaste }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.gypsum"
                                :field="'gypsum'"
                                :is-centred="true">
                                {{ row.gypsum }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.hazNonConform"
                                :field="'hazNonConform'"
                                :is-centred="true">
                                {{ row.hazNonConform }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.insulation"
                                :field="'insulation'"
                                :is-centred="true">
                                {{ row.insulation }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.liquids"
                                :field="'liquids'"
                                :is-centred="true">
                                {{ row.liquids }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.mechTreated"
                                :field="'mechTreated'"
                                :is-centred="true">
                                {{ row.mechTreated }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.metals"
                                :field="'metals'"
                                :is-centred="true">
                                {{ row.metals }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.nonHazNonConform"
                                :field="'nonHazNonConform'"
                                :is-centred="true">
                                {{ row.nonHazNonConform }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.other"
                                :field="'other'"
                                :is-centred="true">
                                {{ row.other }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.packagingPlastic"
                                :field="'packagingPlastic'"
                                :is-centred="true">
                                {{ row.packagingPlastic }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.packagingCard"
                                :field="'packagingCard'"
                                :is-centred="true">
                                {{ row.packagingCard }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.paper"
                                :field="'paper'"
                                :is-centred="true">
                                {{ row.paper }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.plastic"
                                :field="'plastic'"
                                :is-centred="true">
                                {{ row.plastic }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.plasticNonRecyclable"
                                :field="'plasticNonRecyclable'"
                                :is-centred="true">
                                {{ row.plasticNonRecyclable }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.soils"
                                :field="'soils'"
                                :is-centred="true">
                                {{ row.soils }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.tilesCeramics"
                                :field="'tilesCeramics'"
                                :is-centred="true">
                                {{ row.tilesCeramics }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.weee"
                                :field="'weee'"
                                :is-centred="true">
                                {{ row.weee }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.woodNonPackaging"
                                :field="'woodNonPackaging'"
                                :is-centred="true">
                                {{ row.woodNonPackaging }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.woodPackaging"
                                :field="'woodPackaging'"
                                :is-centred="true">
                                {{ row.woodPackaging }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.percentage === true && viewMode === 'materials' && visibleFields.tyres"
                                :field="'tyres'"
                                :is-centred="true">
                                {{ row.tyres }}
                            </DataTableColumn>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="MATERIALS (t)">-->

                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.aggregates"
                                :field="'aggregateWT'"
                                :is-centred="true">
                                {{ row.aggregateWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.asphalt"
                                :field="'asphaltWT'"
                                :is-centred="true">
                                {{ row.asphaltWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.bricks"
                                :field="'bricksWT'"
                                :is-centred="true">
                                {{ row.bricksWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.bulkyWaste"
                                :field="'bulkyWasteWT'"
                                :is-centred="true">
                                {{ row.bulkyWasteWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.canteenOffice"
                                :field="'canteenOfficeWT'"
                                :is-centred="true">
                                {{ row.canteenOfficeWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.concrete"
                                :field="'concreteWT'"
                                :is-centred="true">
                                {{ row.concreteWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.floorCoverings"
                                :field="'floorCoveringsWT'"
                                :is-centred="true">
                                {{ row.floorCoveringsWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.glass"
                                :field="'glassWT'"
                                :is-centred="true">
                                {{ row.glassWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.greenWaste"
                                :field="'greenWasteWT'"
                                :is-centred="true">
                                {{ row.greenWasteWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.gypsum"
                                :field="'gypsumWT'"
                                :is-centred="true">
                                {{ row.gypsumWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.hazNonConform"
                                :field="'hazNonConformWT'"
                                :is-centred="true">
                                {{ row.hazNonConformWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.insulation"
                                :field="'insulationWT'"
                                :is-centred="true">
                                {{ row.insulationWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.liquids"
                                :field="'liquidsWT'"
                                :is-centred="true">
                                {{ row.liquidsWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.mechTreated"
                                :field="'mechTreatedWT'"
                                :is-centred="true">
                                {{ row.mechTreatedWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.metals"
                                :field="'metalsWT'"
                                :is-centred="true">
                                {{ row.metalsWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.nonHazNonConform"
                                :field="'nonHazNonConformWT'"
                                :is-centred="true">
                                {{ row.nonHazNonConformWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.other"
                                :field="'otherWT'"
                                :is-centred="true">
                                {{ row.otherWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.packagingPlastic"
                                :field="'packagingPlasticWT'"
                                :is-centred="true">
                                {{ row.packagingPlasticWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.packagingCard"
                                :field="'packagingCardWT'"
                                :is-centred="true">
                                {{ row.packagingCardWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.paper"
                                :field="'paperWT'"
                                :is-centred="true">
                                {{ row.paperWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.plastic"
                                :field="'plasticWT'"
                                :is-centred="true">
                                {{ row.plasticWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.plasticNonRecyclable"
                                :field="'plasticNonRecyclableWT'"
                                :is-centred="true">
                                {{ row.plasticNonRecyclableWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.soils"
                                :field="'soilsWT'"
                                :is-centred="true">
                                {{ row.soilsWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.tilesCeramics"
                                :field="'tilesCeramicsWT'"
                                :is-centred="true">
                                {{ row.tilesCeramicsWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.weee"
                                :field="'weeeWT'"
                                :is-centred="true">
                                {{ row.weeeWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.woodNonPackaging"
                                :field="'woodNonPackagingWT'"
                                :is-centred="true">
                                {{ row.woodNonPackagingWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.woodPackaging"
                                :field="'woodPackagingWT'"
                                :is-centred="true">
                                {{ row.woodPackagingWT }}
                            </DataTableColumn>
                            <DataTableColumn
                                v-if="viewUnits.amount === true && viewMode === 'materials' && visibleFields.tyres"
                                :field="'tyresWT'"
                                :is-centred="true">
                                {{ row.tyresWT }}
                            </DataTableColumn>

                            <!--</editor-fold>-->


                            <!--<editor-fold desc="CARBON">-->

                            <DataTableColumn v-if="viewMode === 'carbon' && visibleFields.wasteCarbon"
                                             :field="'wasteCarbon'"
                                             :is-centred="true">
                                {{ row.wasteCarbon }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'carbon' && visibleFields.transportCarbon"
                                             :field="'transportCarbon'"
                                             :is-centred="true">
                                {{ row.transportCarbon }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'carbon' && visibleFields.totalCarbon"
                                             :field="'totalCarbon'"
                                             :is-centred="true">
                                {{ row.totalCarbon }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'carbon' && visibleFields.jobDistance"
                                             :field="'jobDistance'"
                                             :is-centred="true">
                                {{ row.jobDistance }}
                            </DataTableColumn>
                            <DataTableColumn v-if="viewMode === 'carbon' && visibleFields.treeCount"
                                             :field="'treeCount'"
                                             :is-centred="true">
                                {{ row.treeCount }}
                            </DataTableColumn>

                            <!--</editor-fold>-->


                        <!--</editor-fold>-->


                    </tr>

                </tbody>


            </table>

        </div>


        <LaravelVuePagination
            :align="'center'"
            :data="rawData.data.table_paginator"
            :limit="3"
            @pagination-change-page="changePage"
        />


    </div>

</template>

<script>
import DataTableHeader from '../ui/DataTableHeader'
import DataTableColumn from '../ui/DataTableColumn'
import LaravelVuePagination from 'laravel-vue-pagination'

export default {
    components: { DataTableColumn, DataTableHeader, LaravelVuePagination },
    props: {
        viewMode: String,
        currentSort: String,
        currentSortDir: String,
        rawData: Object,
        viewUnits: {
            type: Object
        },
        visibleFields: {
            type: Object
        }
    },

    data: function () {
        return {
            sort: {
                by: this.currentSort,
                direction: this.currentSortDir,
            }
        }
    },

    computed: {
        sortedSiteData: function () {
            return this.rawData.data.table
        },
    },

    methods: {
        filesByLine: function (row) {
            return this.rawData.data.files[row.document_number]
        },

        showFileModal: function (line) {
            this.$emit('show:files', line)
        },

        changePage: function (page) {
            this.$emit('page:set', page)
        },

        updateSortProps (payload) {
            this.$emit('update:sort', payload)
        }
    }
}
</script>
